import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import EditVat from "./Editvat.jsx";
import {
  ActiveCell,
  SignatureCell,
  EditCommandCell,
  VatReturnCell,
} from "../GridComponents.jsx";
import { useVats, updateVat } from "../../../services/vatService.js";

const Vatlist = () => {
  const [openForm, setOpenForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState(null);

  const { data: vats = [], isLoading } = useVats();

  const transformedData = vats?.map((item) => ({
    ...item,
    symbol: item.details?.[0] || "",
  }));

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    const data = {
      vatCodeId: event.vatCodeId,
      details: event.details,
      rate: event.rate,
      includeInVatReturn: event.includeInVatReturn,
      active: event.active,
    };
    await updateVat(event.vatCodeId, data);
    setOpenForm(false);
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid">
      <Grid data={transformedData} loading={isLoading} total={vats.length}>
        <Column cell={SignatureCell} title=" " field="symbol" width="80" />
        <Column
          field="vatCodeId"
          title="VAT Code"
          className="ps-4"
          width="120"
        />
        <Column field="details" title="Details" className="text-right ps-3" />
        <Column
          field="rate"
          title="Rate"
          className="text-right ps-3"
          width="80"
        />
        <Column cell={VatReturnCell} title="VAT Return" width="120" />
        <Column cell={ActiveCell} title="Active" width="80" />
        <Column title="Edit" cell={MyEditCommandCell} width="80" />
      </Grid>

      {openForm && (
        <EditVat
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default Vatlist;
